<template>
    <div class="templateInfo">
        <div class="content">
            <div class="info">
                <div class="img">
                    <img :src="'https://www.limingsoftware.top' + templateInfo.image" alt="">
                </div>
                <div class="right">
                    <div class="title">{{ templateInfo.name }}</div>
                    <div class="uptime"><span>更新时间:</span>{{ templateInfo.createtime }}</div>
                </div>
            </div>
            <div class="jianjie">
                <div class="jianjie_header">模板简介</div>
                <div class="jianjie_record">前端技术框架：{{ templateInfo.web_framework }}</div>
                <div class="jianjie_record">后端技术框架：{{ templateInfo.admin_framework }}</div>
                <div class="jianjie_record">开发周期：{{ templateInfo.cycle }}个工作日</div>
                <div class="jianjie_record">人员配置：{{ templateInfo.configuration }}</div>
                <div class="jianjie_record">需要证件和资质：{{ templateInfo.certificate }}</div>
                <div class="jianjie_record">主要功能介绍：<div v-html="templateInfo.function_content"></div>
                </div>
                <div class="jianjie_record"><a :href="formatUrl(templateInfo.web_url)" target="_blank">前端测试链接</a></div>
                <div class="jianjie_record"><a :href="formatUrl(templateInfo.admin_url)" target="_blank">后端测试链接</a></div>
                <div class="jianjie_record">前端测试账号：{{ templateInfo.web_account }}</div>
                <div class="jianjie_record">前端测试密码：{{ templateInfo.web_pwd }}</div>
                <div class="jianjie_record">后端测试账号：{{ templateInfo.admin_account }}</div>
                <div class="jianjie_record">后端测试密码：{{ templateInfo.admin_pwd }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { get, post, put, del } from '@/utils/http'
export default {
    name: 'templateInfo',
    data() {
        return {
            templateInfo: {}
        }
    },
    mounted() {
        this.id = this.$route.query.id
        this.getInfo()
    },
    methods: {
        formatUrl(url) {
            if (!url) return '';
            if (!/^https?:\/\//i.test(url)) {
                url = 'https://' + url;
            }
            return url;
        }, getInfo() {
            post('index/getTemplateDetail', { id: this.id }).then(res => {
                console.log(res)
                if (res.code == 1) {
                    this.templateInfo = res.data
                }
            })
        }
    }
}
</script>

<style scoped>
.content {
    width: 1200px;
    margin: 0 auto;
    min-height: 100vh;
}

.info {
    width: 100%;
    display: flex;
}

.info .img {
    width: 200px;
    height: 200px;

}

.info .img img {
    width: 200px;
    height: 200px;
}

.info .right {
    flex: 1;
    margin-left: 20px;
}

.info .right .title {
    font-size: 16px;
}

.jianjie_header {
    padding: 10px 20px;
    border-bottom: 1px solid #f5f5f5;
    font-weight: 600;
}

.jianjie_record {
    width: 100%;
    font-size: 16px;
    margin-top: 20px;
}
</style>